import { toast } from 'react-toastify';
import { FiCheckCircle, FiAlertCircle, FiInfo } from 'react-icons/fi';

export const toastError = (message: string) => {
  toast.error(message, {
    position: 'top-left',
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: FiAlertCircle,
  });
};

export const toastSuccess = (message: string) => {
  toast.success(message, {
    position: 'top-left',
    autoClose: 1200,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: FiCheckCircle,
  });
};

export const toastInfo = (message: string) => {
  toast.info(message, {
    position: 'top-center',
    autoClose: 800,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    icon: FiInfo,
  });
};
